//States used by AWS-Amplify
const awsStates = {
  SIGN_IN: 'signIn',
  SIGN_UP: 'signUp',
  SIGNED_IN: 'signedIn',
  SIGNED_UP: 'signedUp',
  FORGOT_PASSWORD: 'forgotPassword',
  CONFIRM_SIGN_IN: 'confirmSignIn',
  CONFIRM_SIGN_UP: 'confirmSignUp',
  REQUIRE_NEW_PASSWORD: 'requireNewPassword',
  VERIFY_CONTACT: 'verifyContact',
  TOTP_SETUP: 'TOTPSetup',
};

export default awsStates;